import { render } from "./GameCard.vue?vue&type=template&id=a9bb9bbc&scoped=true"
import script from "./GameCard.vue?vue&type=script&lang=js"
export * from "./GameCard.vue?vue&type=script&lang=js"

import "./GameCard.vue?vue&type=style&index=0&id=a9bb9bbc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tchutchu/tchutchu/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9bb9bbc"]])

export default __exports__